import { css } from '@emotion/react';

export const globalStyles = css`
  /*
   * MUI X v7's PickersMonth/PickersYear styled components emit their
   * ".Mui-selected" rules WITHOUT the parent class scoping (looks like
   * an emotion + generateUtilityClass interaction — every other '&' in
   * the same styled compiles correctly, only "&.Mui-selected" leaks).
   * Once the month picker has mounted, those two global rules:
   *   .Mui-selected { background-color: primary.main; color: contrast; }
   *   .Mui-selected:focus, .Mui-selected:hover { background-color: primary.dark; }
   * sit LATER in the cascade than the commons-ui per-component overrides
   * (same specificity), so they win and paint every selected ToggleButton,
   * ListItemButton, MenuItem etc. solid primary blue after that point.
   *
   * Re-hoist commons-ui's neutral selected styling with matching state
   * selectors so specificity + source order both beat the leaked rules.
   */
  .DnkToggleButton-root.Mui-selected,
  .DnkToggleButton-root.Mui-selected:focus,
  .DnkToggleButton-root.Mui-selected:hover {
    background-color: var(--dnk-palette-neutral-100);
    color: var(--dnk-palette-neutral-900);
  }

  .DnkListItemButton-root.Mui-selected,
  .DnkListItemButton-root.Mui-selected:focus,
  .DnkListItemButton-root.Mui-selected:hover {
    background-color: var(--dnk-palette-background-100);
    color: inherit;
  }

  .DnkMenuItem-root.Mui-selected,
  .DnkMenuItem-root.Mui-selected:focus,
  .DnkMenuItem-root.Mui-selected:hover {
    background-color: var(--dnk-palette-background-100);
    color: inherit;
  }

  /* Inter font - locally hosted (matching Google Fonts format) */
  /* latin-ext */
  @font-face {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 100 900;
    font-display: swap;
    src: url('/fonts/Inter-latin-ext.woff2') format('woff2');
    unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF,
      U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020,
      U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
  }
  /* latin */
  @font-face {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 100 900;
    font-display: swap;
    src: url('/fonts/Inter-latin.woff2') format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
      U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193,
      U+2212, U+2215, U+FEFF, U+FFFD;
  }
`;
